<template>
  <div>
    <div v-if="sortedTemplates.length">
      <table class="table graphic-templates-table" data-test="producer-savedGraphicsModal-templatesTable">
        <thead>
          <tr>
            <th>Preview</th>
            <th class="sortable" v-bind:class="getActiveClass('title')" v-on:click="changeSort('title')">Title<span class="arrow"></span></th>
            <th class="sortable" v-bind:class="getActiveClass('created_time')" v-on:click="changeSort('created_time')">Created date<span class="arrow"></span></th>
            <th class="sortable" v-bind:class="getActiveClass('created_by.displayName')" v-on:click="changeSort('created_by.displayName')">Created by<span class="arrow"></span></th>
          </tr>
        </thead>

        <tbody>
          <table-row
            v-for="template in sortedTemplates"
            :key="template._id"
            class="list-item"
            :template="template"
            :selected="selected"
            :data-test="`producer-savedGraphicsModal-template-${template._id}`"
            @select="select"
          />
        </tbody>

      </table>
    </div>
    <div v-if="!sortedTemplates.length" class="no-templates text-center">
      <p>No results found.</p>
    </div>

    <div class="text-center">
      <paginate v-if="pageCount > 1" :page-count="pageCount" :click-handler="paginate" :prev-text="'Prev'" :next-text="'Next'" container-class="pagination"></paginate>
    </div>
  </div>
</template>

<script>
import { orderBy, size } from 'lodash-es';
import TableRow from './TemplatesTableRow.vue';

export default {
  components: { TableRow },
  props: ['templates', 'selected'],

  data() {
    return {
      sortOrder: 'desc',
      sortCat: 'created_time',
      pageSize: 5,
      offset: 0,
    };
  },

  methods: {
    select(template) {
      this.$emit('select', template);
    },
    getActiveClass(category) {
      if (category === this.sortCat) {
        return `active ${this.sortOrder}`;
      }
      return '';
    },
    changeSort(category) {
      if (category === this.sortCat) {
        this.sortOrder = this.sortOrder == 'asc' ? 'desc' : 'asc';
      } else {
        this.sortCat = category;
      }
    },
    paginate(pageNum) {
      this.offset = this.pageSize * (pageNum - 1);
    },
  },
  computed: {
    sortedTemplates() {
      const sorted = orderBy(this.templates, [this.sortCat], [this.sortOrder]);
      return sorted.slice(this.offset, this.offset + this.pageSize);
    },
    pageCount() {
      return Math.ceil(size(this.templates) / this.pageSize);
    },
    loading() {
      return this.$store.state.templates.loading;
    },
  },
};
</script>
